import React from "react";
import Image from "../Image/Image";
import classes from "./PrimaryButton.module.scss";

const PrimaryButton = (props) => {

  return (
    <button
      id="primaryButtonId"
      className={`${classes.Container} ${props.className} ${props.disabled && classes.DisableBtn
        }`}
      onClick={(e) => props.handleClick(e)}
      disabled={props.disabled}
      data-testid={props.dataTestid}
    >
      <span className={classes.Content}>{props.label}</span>
      {props.filename && (
        <Image
          className={classes.Image}
          filename={props.filename}
          renditions={props.renditions}
          ext={props.ext}
        />
      )}
      {!props.filename && (
        <Image
          className={classes.Image}
          filename={
            props.disabled ? "arrow_forward_black-2" : "arrow_forward_black-1"
          }
          renditions={props.renditions}
          ext={props.ext}
        />
      )}
    </button>
  );
};

export default PrimaryButton;
